<div>
  <p-drawer #drawerRef [(visible)]="visible">
    <ng-template #headless>
      <app-drawer-menu/>
    </ng-template>
  </p-drawer>
  <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
    <app-drawer-menu class="border-r border-gray-200 "/>
  </div>

  <div class="lg:pl-72">
    <div
      class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button (click)="visible = true" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" type="button">
        <span class="sr-only">Open sidebar</span>
        <svg aria-hidden="true" class="size-6" data-slot="icon" fill="none" stroke="currentColor" stroke-width="1.5"
             viewBox="0 0 24 24">
          <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div aria-hidden="true" class="h-6 w-px bg-gray-200 lg:hidden"></div>

      <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <form action="#" class="grid flex-1 grid-cols-1" method="GET">
          <input aria-label="Search"
                 class="col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-none placeholder:text-gray-400 sm:text-sm/6"
                 name="search"
                 placeholder="Search"
                 type="search">
          <svg aria-hidden="true" class="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400"
               data-slot="icon" fill="currentColor" viewBox="0 0 20 20">
            <path clip-rule="evenodd"
                  d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
                  fill-rule="evenodd"/>
          </svg>
        </form>
        <div class="flex items-center gap-x-4 lg:gap-x-6">
          <button class="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500" type="button">
            <span class="sr-only">View notifications</span>
            <svg aria-hidden="true" class="size-6" data-slot="icon" fill="none" stroke="currentColor"
                 stroke-width="1.5" viewBox="0 0 24 24">
              <path
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                stroke-linecap="round"
                stroke-linejoin="round"/>
            </svg>
          </button>

          <div aria-hidden="true" class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"></div>

          <div class="relative">
            <button (click)="profilePopover.toggle($event)" aria-expanded="false" aria-haspopup="true"
                    class="-m-1.5 flex items-center p-1.5"
                    id="user-menu-button" type="button">
              <span class="sr-only">Open user menu</span>
              <span class="inline-flex size-8 items-center justify-center rounded-full bg-indigo-600">
                <span class="text-xs font-medium text-white">{{ initials }}</span>
              </span>
              <span class="hidden lg:flex lg:items-center">
                <span aria-hidden="true"
                      class="ml-4 text-sm/6 font-semibold text-gray-900">{{ currentUser?.fullName || currentUser?.userName }}</span>
                <svg aria-hidden="true" class="ml-2 size-5 text-gray-400" data-slot="icon" fill="currentColor"
                     viewBox="0 0 20 20">
                  <path clip-rule="evenodd"
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        fill-rule="evenodd"/>
                </svg>
              </span>
            </button>
            <p-popover #profilePopover>
              <app-popover-menu/>
            </p-popover>
          </div>
        </div>
      </div>
    </div>

    <main class="py-10">
      <div class="px-4 sm:px-6 lg:px-8">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
